/**
 * Moduł obsługujący gwarancje zakupione w procesie dosprzedaży w eKatalogu
 */
app.service('upsellingWarranties', function (front, modal, loading, pageConfig, ajaxErrorHandler) {

	function init() {
		setEvents();
	}

	function setEvents() {
		$('body').on('click', '.js-subscribe-warranty-upselling-card', function () {
			const subscriptionWarrantyUpsellingId = $(this).attr('data-id');
			subscribeUpsellingWarranty(subscriptionWarrantyUpsellingId);
		}).on('click', '.js-preview-warranty-payment', function() {
			modal.open('preview-warranty-payment');
		});
	}

	function loadUpsellingWarranties() {
		return $.ajax({
			method: 'GET',
			url: '/customer-account-orders-with-upselling-warranty-available.ltr'
		}).fail(ajaxErrorHandler.createFailHandler('upsellingWarranties.loadUpsellingWarranties'));
	}

	function loadAvailableWarrantiesForPreview() {
		return $.ajax({
			method: 'GET',
			url: '/customer-order-upselling-warranties-preview.ltr',
			data: {
				orderNumber: pageConfig.getData('account').orderNumber
			}
		}).fail(ajaxErrorHandler.createFailHandler('upsellingWarranties.loadAvailableWarrantiesForPreview'));
	}

	function subscribeUpsellingWarranty(subscriptionWarrantyUpsellingId) {
		loading.start();
		$.ajax({
			method: 'POST',
			url: '/subscription-warranty-upselling-transaction-payment.ltr',
			data: {
				subscriptionWarrantyUpsellingId
			},
			success(response) {
				if (response.status === 'FAIL') {
					loading.stop();
					modal.alert(response.messages.join(''));
				} else {
					loading.redirect(response.transactionPaymentUrl);
				}
			},
			error(jqXHR, textStatus, errorThrown) {
				const handleError = ajaxErrorHandler.createFailHandler(
					'upsellingWarranties.subscribeUpsellingWarranty',
					'Wystąpiły problemy techniczne. Spróbuj dodać kartę lub BLIKA jeszcze raz lub skontaktuj się z działem pomocy.'
				);
				handleError(jqXHR, textStatus, errorThrown);
			},
			complete() {
				loading.stop();
			}
		});
	}

	return {
		init,
		loadUpsellingWarranties,
		loadAvailableWarrantiesForPreview,
		subscribeUpsellingWarranty
	};
})